module.exports = __webpack_public_path__ + "assets/media/morning.bc511df2.mp3";